<template>

    <div>
        <section class="row">

          <article class="wrap--sm">

            <h3>Din betalingen blev ikke gennemført</h3>

            <p v-html="errorMessage"> </p>

            <a class="btn--primary margin-t-25" href="#" @click.prevent="back">Gå til Betaling</a>


          </article>

        </section>

    </div>

</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    export default {
        data: function () {
            return {
                translatedMessages:{
                    invalid_number: `Kortnummeret er ugyldigt </br>
                    <strong>OBS! Vi modtager IKKE alm. Dankort i shoppen.</strong>
                    `,
                    invalid_expiry_month:'Kortets udløbsmåned er ugyldigt',
                    invalid_expiry_year:'Kortets udløbsår er ugyldigt',
                    invalid_cvc:'Kortets CVC sikkerhedskode er ugyldig',
                    incorrect_number:`Kortnummeret er ikke korrekt </br>
                    <strong>OBS! Vi modtager IKKE alm. Dankort i shoppen.</strong>
                    `,
                    expired_card:'Kortet er udløbet',
                    incorrect_cvc:'Kortets CVC sikkerhedskode er ikke korrekt',
                    incorrect_zip:'Kortets postnummer kan ikke valideres',
                    card_declined:`Kortet blev afvist </br>
                    <strong>OBS! Vi modtager IKKE alm. Dankort i shoppen.</strong>
                    `,
                    missing:'Dette kort er ikke tilknyttet en kunde',
                    processing_error:'Fejl under transaktion'
                }
            }
        },
        computed:{
            ...mapGetters({
             cardError:'getCardError'
            }),
            errorMessage(){
                if(!this.cardError.code)
                {
                    return 'Der skete en fejl under behandlingen af betalingen, prøv venligst igen';
                }
                return this.translatedMessages[this.cardError.code];
            }
        },
        methods: {
            ...mapActions(['setStep']),
            back(){
                this.setStep(2);
            }
        }
    }
</script>
